module.exports = __webpack_public_path__ + "static/media/torso-mid-left-side.e7b179d4.png";